import { REHYDRATE } from 'redux-persist/constants'
import { ADD, CLEAR } from './constants'

const initialState = { ratedContent: [] }

export default function feedbackReducer(state = initialState, action) {
  switch (action.type) {
    case ADD: {
      return {
        ...state,
        ratedContent: [...state.ratedContent, action.content]
      }
    }

    case CLEAR: {
      return {
        ...state,
        ratedContent: []
      }
    }

    case REHYDRATE: {
      return {
        ...state,
        ...action.payload.feedback
      }
    }

    default: {
      return state
    }
  }
}
